// src/pages/AdminFormationContinue.jsx
import React, { useEffect, useState } from 'react';
import PageLayout from '../components/PageLayout';
import { uploadQuestionsFile, listQuestions, updateQuestion } from '../api/formationContinue';
import { createPortal } from 'react-dom';

function QuestionsTable({ questions, refresh }) {
  const handleToggleActif = async (q) => {
    const scrollPosition = window.scrollY;

    try {
      await updateQuestion(q.id, {
        actif: !q.actif,
      });

      await refresh();

      requestAnimationFrame(() => {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'instant',
        });
      });
    } catch (err) {
      console.error('Failed to update question:', err);
    }
  };
  return (
    <>
      <table className="w-full table-fixed divide-y divide-gray-200 bg-white">
        <thead className="bg-gray-50">
          <tr>
            <th className="w-16 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Pop
            </th>
            <th className="w-16 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              #
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Question
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Correct
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Wrong 1
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Wrong 2
            </th>
            <th className="w-24 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">
              Active
            </th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-200">
          {questions.map((q) => (
            <tr key={q.id} className="hover:bg-gray-50">
              <td className="px-6 py-4 text-sm font-medium text-gray-900">{q.pop}</td>

              <td className="px-6 py-4 text-sm font-medium text-gray-900">{q.numerotation}</td>

              <td className="px-6 py-4 text-sm text-blue-600 max-w-md">
                <div className="break-words">{q.question}</div>
              </td>

              <td className="px-6 py-4 text-sm text-green-700">
                <div className="break-words">{q.a_ok}</div>
              </td>

              <td className="px-6 py-4 text-sm text-red-600">
                <div className="break-words">{q.a_w1}</div>
              </td>

              <td className="px-6 py-4 text-sm text-red-600">
                <div className="break-words">{q.a_w2}</div>
              </td>

              <td className="px-6 py-4">
                <button
                  onClick={() => handleToggleActif(q)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                    q.actif ? 'bg-green-600' : 'bg-gray-300'
                  }`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                      q.actif ? 'translate-x-6' : 'translate-x-1'
                    }`}
                  />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default function AdminFormationContinue() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [fileUploadError, setFileUploadError] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showConfirmUpload, setShowConfirmUpload] = useState(false);

  const refresh = async () => {
    setError('');
    setLoading(true);
    try {
      const [qsts] = await Promise.all([listQuestions()]);
      setQuestions(qsts);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    refresh();
  }, []);

  const handleFileChange = async (event) => {
    setFileUploadError('');
    const file = event.target.files?.[0];
    if (!file) return;

    if (!file.name.toLowerCase().endsWith('.tsv')) {
      alert('Veuillez choisir un fichier .tsv');
      event.target.value = '';
      return;
    }

    setSelectedFile(file);
    setShowConfirmUpload(true);
    event.target.value = '';
  };

  const confirmUpload = async () => {
    try {
      await uploadQuestionsFile(selectedFile);
      setShowConfirmUpload(false);
      setSelectedFile(null);
      await refresh();
    } catch (err) {
      console.error(err);
      setFileUploadError(err);
      setShowConfirmUpload(false);
    }
  };

  const cancelUpload = () => {
    setShowConfirmUpload(false);
    setSelectedFile(null);
  };

  return (
    <PageLayout title="Administration — Formation continue">
      <div className="px-4 pt-2 pb-2">
        <h1 className="text-xl font-semibold mb-3">Formation continue</h1>
      </div>

      {showConfirmUpload &&
        createPortal(
          <div className="fixed top-0 left-0 w-full h-[100vh] z-[1002] flex items-center justify-center bg-black/60">
            <div
              className="absolute inset-0 bg-black/30"
              onClick={() => setShowConfirmUpload(false)}
            />
            <div className="relative z-10 mx-3 rounded-2xl bg-white shadow-xl p-4 grid grid-cols-1 gap-2  w-[400px] max-w-[80vh]">
              <div className="mb-4 flex justify-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-4xl">
                  ⚠️
                </div>
              </div>

              <h2 className="mb-2 text-center text-xl font-semibold text-gray-900">
                Confirmer l'import
              </h2>

              <p className="mb-6 text-center text-gray-600">
                L'import du fichier <strong>{selectedFile?.name}</strong> supprimera toutes les
                questions existantes ainsi que toutes les réponses associées.
                <br />
                <br />
                Cette action est irréversible.
              </p>

              <div className="flex justify-end gap-3">
                <button
                  onClick={cancelUpload}
                  className="rounded-lg border border-gray-400 px-4 py-2 text-gray-700 bg-gray-200  hover:bg-gray-300"
                >
                  Annuler
                </button>

                <button
                  onClick={confirmUpload}
                  className="rounded-lg bg-red-600 px-4 py-2 font-medium text-white hover:bg-red-700"
                >
                  Confirmer l'import
                </button>
              </div>
            </div>
          </div>,
          document.body,
        )}

      {loading ? (
        <p className="text-sm text-gray-500 px-4">Chargement…</p>
      ) : error ? (
        <p className="text-sm text-red-600 px-4">{error}</p>
      ) : (
        <div className="mt-3 space-y-2 px-4 pb-8">
          <div className="rounded-xl bg-white p-6 shadow">
            <h2 className="mb-4 text-lg font-semibold text-gray-800">Importer des questions</h2>
            <div className="mb-4">
              <p className="mb-1 font-medium text-gray-700">Format attendu</p>
              <code className="block rounded bg-gray-100 px-3 py-2 font-mono text-sm text-gray-800">
                Pop&nbsp;&nbsp;&nbsp;Q&nbsp;&nbsp;&nbsp;A_OK&nbsp;&nbsp;&nbsp;A_W1&nbsp;&nbsp;&nbsp;A_W2
              </code>
            </div>

            <label className="block">
              <span className="mb-2 block font-medium text-gray-700">
                Sélectionnez un fichier TSV
              </span>
              {fileUploadError && (
                <div className="mb-3 rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm font-medium text-red-700">
                  {fileUploadError.message}
                </div>
              )}

              <input
                type="file"
                accept=".tsv,text/tab-separated-values"
                onChange={handleFileChange}
                className="
                  block w-full cursor-pointer rounded-lg border border-gray-300
                  bg-gray-50 text-sm text-gray-700
                  file:mr-4 file:cursor-pointer file:border-0
                  file:bg-blue-600 file:px-4 file:py-2
                  file:font-medium file:text-white
                  hover:file:bg-blue-700
                "
              />
            </label>
          </div>
          <div className="bg-white rounded-xl shadow p-3">
            <QuestionsTable questions={questions} refresh={refresh} />
          </div>
        </div>
      )}
    </PageLayout>
  );
}
